<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg bmw-lg-obd" (window:orientationchange)="screenRotate($event)"> -->
  <div class="bmw-lg-obd" (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex-14">
        <div class="bmw-lg-obd-sidebar">
          <div class="bmw-obd-sidebar-title">OBD</div>
          <div class="bmw-lg-obds">
            <div *ngIf='!obdDocs'>{{serviceError}}</div>
            <div *ngIf='obdDocs'>
              <div *ngFor='let doc of obdDocs'>
                <div (click)='loadDocContent(doc)' class="bmw-lg-obd-docs pointer" [ngClass]='{"bmw-lg-active-link": docTitle === doc.title && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-lg-active-link": docTitle === doc.title && APP_SETTINGS.isMINI === "true", "rr-lg-active-link": docTitle === doc.title && APP_SETTINGS.isRollsRoyce === "true"}'>{{doc?.title}}</div>
                <!-- <div class="bmw-lg-obd-docs pointer">
                    <a [href]='doc.content[0].documentFileName' target="_blank">{{doc?.title}}</a>
                  </div> -->
              </div>
            </div>
          </div>
          <div class="bmw-lg-obd-filter" *ngIf='obdDocContentObject?.length > 0'>
            <div style="font-weight:bold">Filter by</div>
            <div style="margin-top:15px">Engine/DME</div>
            <div>
              <input placeholder="Select Engine/DME" id="group" [(ngModel)]='inputEngineGroup'>
            </div>
            <div style="margin-top:25px" style="margin-top:15px">Series</div>
            <div>
              <input type="input" placeholder="Enter Model" style="width:80%" [(ngModel)]='inputSeries'>
            </div>
          </div>
          <div class="bmw-lg-obd-sidebar-buttons" *ngIf='obdDocContentObject?.length > 0'>
            <div [ngStyle]='{"background-color": APP_SETTINGS.isMINI==="true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" style="padding:7px"
              (click)='applyFilter()'>Apply Filter</div>
            <div class=" bmw-button-secondary pointer" style="margin-top:15px;padding:7px" (click)='clearFilter()'>Clear Filter</div>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="bmw-lg-obd-content">
          <div class="flex-container row">
            <div class="flex-30"></div>
            <div class="flex-container row flex-align-center flex-40">
              <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
            "rr-active-link" : isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
              <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
              "rr-active-link" : isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                NEW

                <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
              </div>
              <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
              "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
            </div>
            <div class="flex-30"></div>
          </div>
          <div class="bmw-lg-obd-card">
            <div class="bmw-lg-obd-title flex-container row">
              <div class="flex-500-px">{{docTitle}}</div>
              <div class="flex"></div>
              <div class="flex-214-px">
                <form class="input-group" name="findDocs" style="width: 100%">
                  <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal" placeholder="Find OBD" name="techDoc" [(ngModel)]="search4obdDocs">
                  <div class="input-group-btn">
                    <button [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style=" color: white;border-radius:0;top:6px"
                      class="btn btn-default" type="submit">
                      <i class="glyphicon glyphicon-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div *ngIf='docTitle === "Mode $06 Interface Data"'>
              <div class="flex-container row" style="border-bottom:1px solid #e9e9e9;margin-top:15px">
                <div style="display:inherit" class="flex-50">
                  <div style="font-weight:bold;font-size:12px;">Engine/DME</div>
                  <i class="fa pointer" (click)="sortByProperty('engineFamily')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'engineFamily', 'fa-sort-asc bmw-sort-control-asc': (column == 'engineFamily' && isDesc), 'fa-sort-desc': (column == 'engineFamily' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-4"></div>
                <div style="display:inherit" class="flex-30">
                  <div style="font-weight:bold;font-size:12px;">Series</div>
                </div>
                <div class="flex-5"></div>
                <div style="display:inherit" class="flex">
                  <div style="font-weight:bold;font-size:12px;">Year</div>
                  <i class="fa pointer" (click)="sortByProperty('productionDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'productionDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'productionDate' && isDesc), 'fa-sort-desc': (column == 'productionDate' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
              </div>
              <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
              <div *ngIf='obdDocContentObject?.length > 0'>
                <div *ngFor='let doc of obdDocContentObject | filterResults : filter | searchFilter: "engineFamily,productionDate,seriesAsString": search4obdDocs | sortBy: {property: column, direction: direction}'
                  class="bmw-lg-obd-doc flex-container row">
                  <a style="display: flex; flex-grow: 1;" href='mount/obd/{{doc?.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc.id, doc?.engineFamily)'>
                    <div style="display:inherit" class="flex-50" [innerHTML]='doc?.engineFamily'></div>
                    <div class="flex-4"></div>
                    <div class="flex-30">
                      <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                        {{series?.seriesName}}
                      </div>
                      <div class="pointer" *ngIf='((doc?.series | loadMoreItems : numOfItems).length < doc?.series.length)' (click)='numOfItems = numOfItems + 6'
                        [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style='float: left'>+6</div>
                    </div>
                    <div class="flex-5"></div>
                    <div style="display:inherit" class="flex" [innerHTML]='doc?.productionDate'></div>
                  </a>
                </div>
              </div>
            </div>
            <div *ngIf='docTitle !== "Mode $06 Interface Data"'>
              <!-- <div *ngIf='!obdDocContentObject'>{{serviceError}}</div> -->
              <div class="flex-container row" style="border-bottom:1px solid #e9e9e9;margin-top:15px">
                <div style="display:inherit" class="flex-35">
                  <div style="font-weight:bold;font-size:12px;">Engine Family</div>
                  <i class="fa pointer" (click)="sortByProperty('engineFamily')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'engineFamily', 'fa-sort-asc bmw-sort-control-asc': (column == 'engineFamily' && isDesc), 'fa-sort-desc': (column == 'engineFamily' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-4"></div>
                <div style="display:inherit" class="flex-17">
                  <div style="font-weight:bold;font-size:12px;">Engine/Trans Type</div>
                </div>
                <div class="flex-7"></div>
                <div style="display:inherit" class="flex-17">
                  <div style="font-weight:bold;font-size:12px;">Series</div>
                </div>
                <div class="flex-5"></div>
                <div style="display:inherit" class="flex">
                  <div style="font-weight:bold;font-size:12px;">Date</div>
                  <i class="fa pointer" (click)="sortByProperty('productionDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'productionDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'productionDate' && isDesc), 'fa-sort-desc': (column == 'productionDate' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
              </div>
              <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
              <div *ngIf='obdDocContentObject?.length > 0'>
                <div *ngFor='let doc of obdDocContentObject | filterResults : filter | searchFilter: "engineFamily,engineAsString,productionDate,seriesAsString": search4obdDocs | sortBy: {property: column, direction: direction}'
                  class="flex-container row" style="border-bottom:1px solid #e9e9e9" class="bmw-lg-obd-doc">
                  <a style="display: flex; flex-grow: 1;" href='mount/obd/{{doc?.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc.id, doc?.engineFamily)'>
                    <div style="display:inherit" class="flex-35" [innerHTML]='doc?.engineFamily'></div>
                    <div class="flex-4"></div>
                    <div class="flex-17">
                      <div *ngFor='let type of doc?.engines | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                        {{type?.engineName}}
                      </div>
                      <div class="pointer" *ngIf='((doc?.engines | loadMoreItems : numOfItems).length < doc?.engines.length)' [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}'
                        style='float: left'>+6</div>
                    </div>
                    <div class="flex-7"></div>
                    <div class="flex-17">
                      <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                        {{series?.seriesName}}
                      </div>
                      <div class="pointer" *ngIf='((doc?.series | loadMoreItems : numOfItems).length < doc?.series.length)' (click)='numOfItems = numOfItems + 6'
                        [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style='float: left'>+6</div>
                    </div>
                    <div class="flex-5"></div>
                    <div style="display:inherit" class="flex" [innerHTML]='getProductionDateBounds(doc.productionDate)'>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md bmw-md-obd" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-md-obd" (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class='flex-14'>
        <div class="bmw-md-obd-sidebar">
          <div class="bmw-obd-sidebar-title">OBD</div>
          <div class="bmw-md-obds">
            <div *ngIf='!obdDocs'>{{serviceError}}</div>
            <div *ngIf='obdDocs'>
              <div *ngFor='let doc of obdDocs' class="bmw-md-obd-docs">
                <div (click)='loadDocContent(doc)' class="bmw-md-obd-docs" [ngClass]='{"bmw-lg-active-link": docTitle === doc.title && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-lg-active-link": docTitle === doc.title && APP_SETTINGS.isMINI === "true",
              "rr-lg-active-link": docTitle === doc.title && APP_SETTINGS.isRollsRoyce === "true"}'>{{doc.title}}</div>
              </div>
            </div>
          </div>
          <div class="bmw-lg-obd-filter" *ngIf='obdDocContentObject?.length > 0'>
            <div style="font-weight:bold">Filter by</div>
            <div style="margin-top:15px">Engine/DME</div>
            <div>
              <input placeholder="Select Engine/DME" id="group" [(ngModel)]='inputEngineGroup'>
            </div>
            <div style="margin-top:25px" style="margin-top:15px">Series</div>
            <div>
              <input type="input" placeholder="Enter Model" style="width:80%" [(ngModel)]='inputSeries'>
            </div>
          </div>
          <div class="bmw-lg-obd-sidebar-buttons" *ngIf='obdDocContentObject?.length > 0'>
            <div [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" style="padding:7px"
              (click)='applyFilter()'>Apply Filter</div>
            <div class=" bmw-button-secondary pointer" style="margin-top:15px;padding:7px" (click)='clearFilter()'>Clear Filter</div>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="bmw-md-obd-content">
          <div class="flex-container row">
            <div class="flex-20"></div>
            <div class="flex-container row flex-align-center flex-60">
              <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
            "rr-active-link" : isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
              <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
              "rr-active-link" : isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                NEW
                <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
              </div>
              <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
              "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
            </div>
            <div class="flex-20"></div>
          </div>
          <div class="bmw-md-obd-card">
            <div class="bmw-md-obd-title flex-container row">
              <div class="60">{{docTitle}}</div>
              <div class="flex"></div>
              <div class="flex-202-px">
                <form class="input-group" name="findDocs" style="width: 100%">
                  <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find OBD" name="techDoc"
                    [(ngModel)]="search4techDocs">
                  <div class="input-group-btn">
                    <button [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style=" color: white;border-radius:0;top:2px"
                      class="btn btn-default" type="submit">
                      <i class="glyphicon glyphicon-search"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div *ngIf='docTitle === "Mode $06 Interface Data"'>
              <div *ngIf='obdDocContentObject?.length > 0'>
                <div class="flex-container row" style="border-bottom:1px solid #e9e9e9;margin-top:15px">
                  <div style="display:inherit" class="flex-50">
                    <div style="font-weight:bold;font-size:12px;">Engine/DME</div>
                    <i class="fa pointer" (click)="sortByProperty('engineFamily')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'engineFamily', 'fa-sort-asc bmw-sort-control-asc': (column == 'engineFamily' && isDesc), 'fa-sort-desc': (column == 'engineFamily' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-4"></div>
                  <div style="display:inherit" class="flex-30">
                    <div style="font-weight:bold;font-size:12px;">Series</div>
                  </div>
                  <div class="flex-7"></div>
                  <div style="display:inherit" class="flex">
                    <div style="font-weight:bold;font-size:12px;">Year</div>
                    <i class="fa pointer" (click)="sortByProperty('productionDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'productionDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'productionDate' && isDesc), 'fa-sort-desc': (column == 'productionDate' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                </div>
              </div>
              <div *ngFor='let doc of obdDocContentObject | filterResults : filter | searchFilter: "engineFamily,productionDate,seriesAsString": search4obdDocs | sortBy: {property: column, direction: direction}'
                class="bmw-lg-obd-doc flex-container row">
                <a style="display: flex; flex-grow: 1;" href='mount/obd/{{doc?.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc.id, doc?.engineFamily)'>
                  <div style="display:inherit" class="flex-50" [innerHTML]='doc?.engineFamily'></div>
                  <div class="flex-4"></div>
                  <div class="flex-30">
                    <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                      {{series?.seriesName}}
                    </div>
                    <div class="pointer" *ngIf='((doc?.series | loadMoreItems : numOfItems).length < doc?.series.length)' (click)='numOfItems = numOfItems + 6'
                      [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style='float: left'>+6</div>
                  </div>
                  <div class="flex-7"></div>
                  <div style="display:inherit" class="flex" [innerHTML]='doc?.productionDate'></div>
                </a>
              </div>
            </div>
            <div *ngIf='docTitle !== "Mode $06 Interface Data"'>
              <div class="flex-container row" style="border-bottom:1px solid #e9e9e9;margin-top:15px">
                <div style="display:inherit" class="flex-40">
                  <div style="font-weight:bold;font-size:12px;">Engine Family</div>
                  <i class="fa pointer" (click)="sortByProperty('engineFamily')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'engineFamily', 'fa-sort-asc bmw-sort-control-asc': (column == 'engineFamily' && isDesc), 'fa-sort-desc': (column == 'engineFamily' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-4"></div>
                <div style="display:inherit" class="flex-17">
                  <div style="font-weight:bold;font-size:12px;">Engine/Trans Type</div>
                </div>
                <div class="flex-4"></div>
                <div style="display:inherit" class="flex-18">
                  <div style="font-weight:bold;font-size:12px;">Series</div>
                </div>
                <div class="flex-4"></div>
                <div style="display:inherit" class="flex">
                  <div style="font-weight:bold;font-size:12px;">Date</div>
                  <i class="fa pointer" (click)="sortByProperty('productionDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'productionDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'productionDate' && isDesc), 'fa-sort-desc': (column == 'productionDate' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
              </div>
              <div *ngFor='let doc of obdDocContentObject | filterResults : filter | searchFilter: "engineFamily,engines,productionDate,seriesAsString": search4obdDocs | sortBy: {property: column, direction: direction}'
                style="border-bottom:1px solid #e9e9e9" class="bmw-lg-obd-doc flex-container row">
                <a style="display: flex; flex-grow: 1;" href='mount/obd/{{doc?.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc.id, doc?.engineFamily)'>
                  <div style="display:inherit" class="flex-40" [innerHTML]='doc?.engineFamily'></div>
                  <div class="flex-4"></div>
                  <div class="flex-17">
                    <div *ngFor='let type of doc?.engines | loadMoreItems : numOfItems' style="float: left; margin-right:10px">
                      {{type?.engineName}}
                    </div>
                    <div class="pointer" *ngIf='((doc?.engines | loadMoreItems : numOfItems).length < doc?.engines.length)' [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}'
                      style='float: left'>+6</div>
                  </div>
                  <div class="flex-4"></div>
                  <div class="flex-18">
                    <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:10px">
                      {{series?.seriesName}}
                    </div>
                    <div class="pointer" *ngIf='((doc?.series | loadMoreItems : numOfItems).length < doc?.series.length)' (click)='numOfItems = numOfItems + 6'
                      [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style='float: left'>+6</div>
                  </div>
                  <div class="flex-4"></div>
                  <div style="display:inherit" class="flex" [innerHTML]='doc.productionDate'></div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm bmw-sm-obd" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-sm-obd" (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row space-around-center" style="height: 56px">
      <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
    "rr-active-link" :isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
      <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
      "rr-active-link" :isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
        NEW
        <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
      </div>
      <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
      "rr-active-link" :isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
    </div>
    <div class="bmw-sm-obd-doc-content">
      <div style="text-align: right;padding:15px 15px 0 0" data-toggle="modal" data-target="#filterModal" *ngIf='obdDocContentObject?.length > 0'>
        <i class="material-icons filter-icon">filter_list</i>
        <div class="bmw-sib-filter-label">Filter</div>
      </div>
      <div class="bmw-xs-obd-title flex-container row justify-center-align-center" >
        OBD
      </div>
      <div class="flex-container row justify-center-align-center">
        <form class="input-group" name="findDocs" style="width: 40%">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find OBD" name="techDoc"
            [(ngModel)]="search4techDocs">
          <div class="input-group-btn">
            <button [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style=" color: white;border-radius:0;top:2px"
              class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div *ngFor='let mainDoc of obdDocs;let i=index' style="margin-top:20px">
        <a [ngClass]='{"active": expandOBDDoc[i]}' data-toggle="collapse"
          [href]='"#technicalDocuments" + i' class="bmw-sm-obd-content-doc-title flex-container row flex-align-center">
          <div class="flex">{{mainDoc?.title}}</div>
          <div class="flex"></div>
          <i class="material-icons bmw-xs-obd-toggle-expand-icon flex-30-px" [ngClass]='{"active": expandOBDDoc[i]}' (click)='expandOBDDoc[i] = !expandOBDDoc[i]'>arrow_drop_down</i>
        </a>
        <div class="collapse" [id]='"technicalDocuments" + i'>
          <div *ngIf='mainDoc?.title === "Mode $06 Interface Data"'>
            <div *ngFor='let doc of mainDoc?.content | filterResults : filter | searchFilter: "engineFamily,productionDate,seriesAsString": search4obdDocs | sortBy: {property: column, direction: direction}'
              style="border-bottom:1px solid #e9e9e9;margin:0 15px" class="bmw-lg-obd-doc flex-container row">
              <a href={{doc?.documentFileName}} target="_blank" (click)='saveToHistory(isShowHistory, doc.id, doc?.engineFamily)'>
                <div style="display:inherit" class="flex-50" [innerHTML]='doc.engineFamily'></div>
                <div class="flex-4"></div>
                <div class="flex-30">
                  <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                    {{series?.seriesName}}
                  </div>
                  <div class="pointer" *ngIf='((doc?.series | loadMoreItems : numOfItems).length < doc?.series.length)' (click)='numOfItems = numOfItems + 6'
                    [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style='float: left'>+6</div>
                </div>
                <div class="flex-7"></div>
                <div style="display:inherit" class="flex" [innerHTML]='doc.productionDate'></div>
              </a>
            </div>
          </div>
          <div *ngIf='mainDoc?.title !== "Mode $06 Interface Data"'>
            <div *ngFor='let doc of mainDoc?.content | filterResults : filter | searchFilter: "engineFamily,engines,productionDate,seriesAsString": search4obdDocs | sortBy: {property: column, direction: direction}'
              style="border-bottom:1px solid #e9e9e9;margin:0 15px" class="bmw-lg-obd-doc flex-container row">
              <a href={{doc?.documentFileName}} target="_blank" (click)='saveToHistory(isShowHistory, doc.id, doc?.engineFamily)'>
                <div style="display:inherit" class="flex-40" [innerHTML]='doc.engineFamily'></div>
                <div class="flex-4"></div>
                <div class="flex-17">
                  <div *ngFor='let type of doc?.engines | loadMoreItems : numOfItems' style="float: left; margin-right:10px">
                    {{type?.engineName}}
                  </div>
                  <div class="pointer" *ngIf='((doc?.engines | loadMoreItems : numOfItems).length < doc?.engines.length)' [ngStyle]='{"color":APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}'
                    style='float: left'>+6</div>
                </div>
                <div class="flex-4"></div>
                <div class="flex-18">
                  <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:10px">
                    {{series?.seriesName}}
                  </div>
                  <div class="pointer" *ngIf='((doc?.series | loadMoreItems : numOfItems).length < doc?.series.length)' (click)='numOfItems = numOfItems + 6'
                    [ngStyle]='{"color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}' style='float: left'>+6</div>
                </div>
                <div class="flex-4"></div>
                <div style="display:inherit" class="flex" [innerHTML]='doc?.productionDate'></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade bmw-sm-modal-dialog" id="filterModal" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Sort by</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputSortBy' class="bmw-lg-results-select-sortby">
                  <option [ngValue]="undefined" disabled selected> Sort By </option>
                  <option *ngFor='let sort of sortBy' [ngValue]='sort.key'>{{sort.value}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter" style="margin-top:15px">Engine/DME</div>
            <div>
              <input placeholder="Select Engine/DME" id="group" [(ngModel)]='inputEngineGroup'>
            </div>
            <div style="margin-top:25px" style="margin-top:15px">Series</div>
            <div>
              <input type="input" placeholder="Enter Model" style="width:30%" [(ngModel)]='inputSeries'>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6" style="padding-right:10%">
                <div class="bmw-button-secondary" style="border:2px solid #fff;padding:5px" (click)='clearFilter()'>Clear Filter</div>
              </div>
              <div class="col-xs-6" style="padding-right:10%">
                <div data-dismiss="modal" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' class="bmw-button-primary"
                  style="border:2px solid #1c69d4;padding:5px" (click)='applyFilter()'>Apply Filter</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs bmw-xs-obd" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-xs-obd" (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row space-around-center" style="height: 56px">
      <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
      "rr-active-link" :isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
      <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
      "rr-active-link" :isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
        NEW
        <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
      </div>
      <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
      "rr-active-link" :isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
        class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
    </div>
    <div class="bmw-xs-obd-content">
      <div style="text-align: right;padding:15px 15px 0 0" data-toggle="modal" data-target="#filterModal1" *ngIf='obdDocContentObject?.length > 0'>
        <i class="material-icons filter-icon">filter_list</i>
        <div class="bmw-sib-filter-label">Filter</div>
      </div>
      <div class="bmw-xs-obd-title flex-container row justify-center-align-center">
        OBD
      </div>
      <div class="flex-container row justify-center-align-center">
        <form class="input-group" name="findDocs" style="width: 90%">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find OBD" name="techDoc"
            [(ngModel)]="search4techDocs">
          <div class="input-group-btn">
            <button [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' style=" color: white;border-radius:0;top:2px"
              class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div *ngFor='let mainDoc of obdDocs;let i=index'>
        <a class="flex-container row flex-align-center" [ngClass]='{"active": expandOBDDoc[i]}' data-toggle="collapse"
          [href]='"#technicalDocuments" + i' class="bmw-xs-tech-content-doc-title">
          <div class="flex-250-px">{{mainDoc?.title}}</div>
          <div class="flex"></div>
          <i class="material-icons bmw-xs-obd-toggle-expand-icon flex-30-px" [ngClass]='{"active": expandOBDDoc[i]}' (click)='expandOBDDoc[i] = !expandOBDDoc[i]'>arrow_drop_down</i>
        </a>
        <div class="collapse" [id]='"technicalDocuments" + i'>
          <div *ngFor='let doc of mainDoc?.content | searchFilter: "engineFamily, engines, productionDate,seriesAsString": search4techDocs | filterResults: filter | sortBy: {property: column, direction: direction}'>
            <a href={{doc.documentFileName}} target="_blank" (click)='saveToHistory(isShowHistory, doc.id, doc?.engineFamily)'>
              <div class="bmw-xs-obd-doc-item">
                <div style="padding-bottom: 15px">
                  <div class="flex-container row">
                    <div *ngFor='let type of doc?.engines | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                      {{type?.engineName}}
                    </div>
                    <div style="text-align:right" [innerHTML]='doc.productionDate'></div>
                  </div>
                  <div [innerHTML]='doc?.engineFamily'></div>
                </div>
                <div style="line-height:2.5;height:22px;border-top: 1px solid #e6e7e8;">
                  <div *ngFor="let series of doc?.series | loadMoreItems: numOfItems" style="float:left;margin-left:5px">
                    {{series.seriesName}}
                  </div>
                  <div *ngIf='((doc?.series | loadMoreItems : numOfItems).length < doc?.series.length)' (click)='numOfItems = numOfItems + 6'
                    style="color:#1c69d4;float:left;padding-left:10px;line-height:0.8">+6</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="filterModal1" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Sort by</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputSortBy' class="bmw-lg-results-select-sortby">
                  <option [ngValue]="undefined" disabled selected> Sort By </option>
                  <option *ngFor='let sort of sortBy' [ngValue]='sort.key'>{{sort.value}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter" style="margin-top:15px">Engine/DME</div>
            <div>
              <input placeholder="Select Engine/DME" id="group" [(ngModel)]='inputEngineGroup'>
            </div>
            <div style="margin-top:25px" style="margin-top:15px">Series</div>
            <div>
              <input type="input" placeholder="Enter Model" style="width:30%" [(ngModel)]='inputSeries'>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6" style="padding-right:10%">
                <div class="bmw-button-secondary" style="border:2px solid #fff;padding:5px" (click)='clearFilter()'>Clear Filter</div>
              </div>
              <div class="col-xs-6" style="padding-right:10%">
                <div data-dismiss="modal" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22": APP_SETTINGS.isRollsRoyce === "true" ? "#281432" : "#1c69d4"}' class="bmw-button-primary"
                  style="border:2px solid #1c69d4;padding:5px" (click)='applyFilter()'>Apply Filter</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>